import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { getPages as getPagesApi, Page } from '../../api';

export type PagesState = Page[] | [];

const initialState = [] as PagesState;

export const getPages = createAsyncThunk('pages/getPages', (payload: { isAuthenticated: boolean }, { getState }) => {
  const state = getState() as RootState;

  const { isAuthenticated } = payload;

  // get all feature flags from redux store
  return getPagesApi(isAuthenticated, state.user.hasApprovalFlowEnabled, state.user.hasSelfServiceEnabled);
});

const pageSlice = createSlice({
  name: 'pages',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getPages.fulfilled, (state, action: PayloadAction<Page[]>) => {
      return [...action.payload]; // eslint-disable-line
    });
  },
});

export const selectPages = (state: RootState): Page[] =>
  state.pages.filter((page: Page) => (page.tableauFlagIsRequired ? state.user.hasTableauEnabled : true));

export const selectOnlyDesktopPages = (state: RootState): Page[] =>
  state.pages
    .filter((page: Page) => !page.isMobileOnly)
    .filter((page: Page) => (page.tableauFlagIsRequired ? state.user.hasTableauEnabled : true));

export default pageSlice.reducer;
